/**
 * StaffResetPasswordRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * StaffResetPasswordRes
 */
export interface StaffResetPasswordRes {
  /** 重置成功 */
  success?: boolean
}

/**
 * StaffResetPasswordRes Schema
 */
export const StaffResetPasswordResSchema: SchemaDefinition = {
  properties: {
    success: {
      description: '重置成功',
      format: 'bool',
      type: 'boolean',
      label: '重置成功',
    },
  },
  type: 'object',
}
